const Reducer = (state, action) => {
  let loading;
  switch (action.type) {
    case 'LOADING_USER_OBJECTS':
      loading = { ...state.loading };
      if (action.payload && action.payload.type) {
        loading[action.payload.type] = action.payload.loading;
      }
      return {
        ...state,
        loading,
      };

    case 'GET_USER_OBJECTS':
      let savedItems = {};
      if (action.payload && action.payload.type && action.payload.data) {
        savedItems[action.payload.type] = action.payload.data;
      }
      loading = { ...state.loading };
      if (action.payload && action.payload.type) {
        loading[action.payload.type] = false;
      }
      return {
        ...state,
        ...savedItems,
        loading,
      };

    case 'CREATE_USER_OBJECT':
      let saveItems = {};
      if (action.payload && action.payload.type && action.payload.data) {
        saveItems[action.payload.type] = action.payload.data;
      }
      return {
        ...state,
        ...saveItems,
      };

    case 'UPDATE_USER_OBJECTS':
      let updateItems = {};
      if (action.payload && action.payload.type && action.payload.data) {
        updateItems[action.payload.type] = action.payload.data;
      }
      return {
        ...state,
        ...updateItems,
      };

    case 'DELETE_USER_OBJECT':
      var newState = {
        ...state,
      };

      newState[action.payload.type] = (state[action.payload.type] || []).filter(
        (x) => x.id !== action.payload.id && x.userobject?.id !== action.payload.id
      );

      return {
        ...newState,
      };

    default:
      return state;
  }
};

export default Reducer;
